import { render, staticRenderFns } from "./comLayout1.vue?vue&type=template&id=5b1b4cc4&scoped=true&"
import script from "./comLayout1.vue?vue&type=script&lang=js&"
export * from "./comLayout1.vue?vue&type=script&lang=js&"
import style0 from "./comLayout1.vue?vue&type=style&index=0&id=5b1b4cc4&scoped=true&lang=scss&"
import style1 from "./comLayout1.vue?vue&type=style&index=1&id=5b1b4cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b4cc4",
  null
  
)

export default component.exports